import { StructureProductType } from "@ac-expo/api-types";
import { FileType } from "@prisma/client";
import { cn } from "../../utils";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./Carousel";
import { ProductThumbnail } from "./ProductThumbnail";

type ProductImageCarouselProps = {
  images: StructureProductType["images"];
  productName?: string;
  getFileUrl: (key?: string, type?: FileType, width?: number) => string;
  className?: string;
  canShowCarousel?: boolean;
};

export const ProductImageCarousel = ({
  images,
  productName = "Produit",
  getFileUrl,
  className,
  canShowCarousel = true,
}: ProductImageCarouselProps) => {
  const allImages = images ?? [];
  const imagesList = canShowCarousel ? allImages : allImages.slice(0, 1);
  const hasMultipleImages = imagesList.length > 1;

  if (imagesList.length === 0) {
    return (
      <div className={cn("relative", className)}>
        <ProductThumbnail imageUrl="" altContent={productName} />
      </div>
    );
  }

  return (
    <div
      className={cn("relative", className)}
      onClickCapture={(e) => e.preventDefault()}
    >
      <Carousel>
        <CarouselContent>
          {imagesList.map((image, index) => {
            const fileUrl = getFileUrl(image?.file?.key, image?.file?.type, 200);
            return (
              <CarouselItem key={index}>
                <ProductThumbnail
                  imageUrl={fileUrl}
                  altContent={`${productName} - Image ${index + 1}`}
                />
              </CarouselItem>
            );
          })}
        </CarouselContent>
        {hasMultipleImages && (
          <>
            <CarouselPrevious className="left-2" />
            <CarouselNext className="right-2" />
          </>
        )}
      </Carousel>
    </div>
  );
};
